import { useAccessQuery } from './queries'

import { UNAUTHORIZED, FORBIDDEN } from '../../constants/errors'

export const useAccess = () => {
  const queryAttributes = useAccessQuery()

  return {
    ...queryAttributes,
    isUnauthorized: checkIfUnauthorized(queryAttributes.error),
    isForbidden: checkIfForbidden(queryAttributes.error),
  }
}

const checkIfUnauthorized = err => {
  if (err == null) return false

  return err.response.status === UNAUTHORIZED
}

const checkIfForbidden = err => {
  if (err == null) return false

  return err.response.status === FORBIDDEN
}
